import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'

import { SelectInput } from '../Inputs/Inputs.jsx'
import AppDispatcher from '../../../dispatchers/AppDispatcher'
import styles from '../../../../css/devicePage.module.css'

const options = {
  deviceType: [
    { value: 'binDicator', name: 'Bins' },
    { value: 'coldAirDrain', name: 'Cold Air Drain' },
    { value: 'flow', name: 'Flow Meter' },
    { value: 'moistureSensor', name: 'Moisture Sensor' },
    { value: 'other', name: 'Other' },
    { value: 'pump', name: 'Pump' },
    { value: 'pumpFrostWater', name: 'Frost Water Pump' },
    { value: 'temperature', name: 'Temperature' },
    { value: 'windMachine', name: 'Wind Machine' },
    { value: 'valve', name: 'Valve' },
  ],
}

export const DeviceTypeName = function DeviceTypeName (deviceType) {
  const obj = options.deviceType.find(option => option.value === deviceType)
  if (
    typeof obj === 'object' &&
    typeof obj.name === 'string'
  ) {
    return obj.name
  }
  return 'Uknown Device Type'
}

const DeviceType = ({ device }) => {
  const [deviceType, setDeviceType] = useState(device.physical.deviceType)

  const appDispatch = useCallback(() => {
    AppDispatcher.dispatch({
      action: 'change-physical',
      setting: {
        deviceType,
      },
    })
  }, [deviceType])

  useEffect(() => {
    appDispatch()
  }, [deviceType])

  const handleChange = useCallback((field, value, callback) => {
    setDeviceType(value)
  }, [appDispatch])

  const childChange = useCallback((event) => {
    handleChange(event.target.name, event.target.value)
  }, [handleChange])

  return (
    <div>
      <section className={`${styles.simpleLink} ${styles.simpleLinkBorderPhysical}`}>
        <h5>
          Device Type
        </h5>
        <div className={styles.simpleLinkValueEdit}>
          <SelectInput
            value={deviceType}
            field='deviceType'
            childChange={childChange}
            options={options.deviceType}
            style={styles.settingSelectInput}
          />
        </div>
      </section>
    </div>
  )
}

DeviceType.propTypes = {
  device: PropTypes.object.isRequired,
}

export default DeviceType
